export const SCHEMA = {
    "@context": "http://schema.org",
    "@type": "Organization",
    name: "1mg",
    url: "https://www.1mg.com",
    sameAs: [
        "https://www.facebook.com/1mgOfficial/",
        "https://twitter.com/1mgofficial",
        "https://plus.google.com/+Healthkartplus",
        "https://www.linkedin.com/company/1mg",
        "https://www.youtube.com/channel/UCNUvsEya-Jq_Pw1t6R47hew",
    ],
}
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
export const PDP_OLD_DLS_VISITOR_ID_LIMIT = "49"
export const RUPEE_SYMBOL = "₹"
export const MRP = "MRP"
